var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"input-group"},[_c('input',{staticClass:"form-control",attrs:{"type":"text","id":_vm.id,"placeholder":"0"},domProps:{"value":_vm.enteredValue},on:{"keyup":_vm.validateValue}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }